import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
 
import { TRANSLATIONS_PL } from "./pl/translations";
import { TRANSLATIONS_EN } from "./en/translations";


const { REACT_APP_MY_LANG, REACT_APP_MY_URL, REACT_APP_MY_API_URL } = process.env;

i18n
 .use(LanguageDetector)
 .use(initReactI18next)
 .init({
   resources: {
     en: {
       translation: TRANSLATIONS_EN
     },
     pl: {
       translation: TRANSLATIONS_PL
     }
   }
 });
 
i18n.changeLanguage(REACT_APP_MY_LANG);